/* OWL — Acercar con CLIC en el visor de producto (solo DESKTOP / puntero fino).
 *
 * El componente del tema `drag-zoom-wrapper` maneja el acercar por TAP/PINCH
 * pero SOLO en movil (sus listeners se activan tras `isMobileBreakpoint()`).
 * En escritorio no hay interaccion: por defecto el clic solo cerraba el visor.
 *
 * Este script agrega, SOLO en escritorio con puntero fino, el patron:
 *   - clic sobre la foto  -> acerca (scale) centrado en el punto clicado
 *   - mover el cursor      -> recorre la imagen (transform-origin sigue al cursor)
 *   - clic de nuevo        -> vuelve al fit (imagen completa)
 *
 * No toca el flujo movil (matchMedia lo excluye) ni el markup del tema: solo
 * escribe transform/transform-origin INLINE en el contenedor `.product-media`
 * (el tema anula el `transform` de la `<img>` en desktop, pero un DIV si lo
 * acepta; el wrapper tiene overflow y lo recorta como visor). En reposo limpia
 * el inline y la imagen vuelve al fit (owl-pdp.css con object-fit: contain).
 */
(function () {
  var ZOOM = 2.2; // nivel de acercamiento al hacer clic
  var mq = window.matchMedia('(hover: hover) and (pointer: fine)');
  var WRAP = '.dialog-zoomed-gallery .product-media__drag-zoom-wrapper';

  function wrapperFrom(el) {
    return el && el.closest ? el.closest(WRAP) : null;
  }

  // El elemento que se escala es el DIV `.product-media` (la img no admite
  // transform en desktop en este tema); el wrapper con overflow lo recorta.
  function mediaOf(wrapper) {
    return wrapper ? wrapper.querySelector('.product-media') : null;
  }

  // Coloca el transform-origin donde esta el cursor (fraccion 0..1 del elemento).
  function followCursor(media, event) {
    var r = media.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var fx = Math.min(1, Math.max(0, (event.clientX - r.left) / r.width));
    var fy = Math.min(1, Math.max(0, (event.clientY - r.top) / r.height));
    media.style.transformOrigin = (fx * 100).toFixed(2) + '% ' + (fy * 100).toFixed(2) + '%';
  }

  function zoomOut(wrapper) {
    var media = mediaOf(wrapper);
    if (media) {
      media.style.transform = '';
      media.style.transformOrigin = '';
    }
    wrapper.classList.remove('owl-zoomed');
  }

  // Limpia cualquier acercamiento activo (al cerrar/reabrir el visor).
  function resetAll() {
    document.querySelectorAll(WRAP + '.owl-zoomed').forEach(zoomOut);
  }

  // CLIC: alterna acercar/alejar. Se usa la fase de CAPTURA + stopPropagation
  // para ganarle al `on:click="/close"` que el tema pone en el <li> del visor.
  document.addEventListener(
    'click',
    function (event) {
      if (!mq.matches) return;
      var wrapper = wrapperFrom(event.target);
      if (!wrapper) return;

      var media = mediaOf(wrapper);
      if (!media) return;

      // Evita que el clic sobre la foto CIERRE el visor.
      event.stopPropagation();
      event.preventDefault();

      if (wrapper.classList.contains('owl-zoomed')) {
        zoomOut(wrapper);
      } else {
        followCursor(media, event);
        media.style.transform = 'scale(' + ZOOM + ')';
        wrapper.classList.add('owl-zoomed');
      }
    },
    true
  );

  // MOVER: mientras esta acercado, el origen sigue al cursor (paneo).
  document.addEventListener('mousemove', function (event) {
    if (!mq.matches) return;
    var wrapper = wrapperFrom(event.target);
    if (!wrapper || !wrapper.classList.contains('owl-zoomed')) return;
    followCursor(mediaOf(wrapper), event);
  });

  // Al cerrar el visor (Escape o boton X), volver todo al fit.
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') resetAll();
  });
  document.addEventListener(
    'click',
    function (event) {
      if (event.target && event.target.closest && event.target.closest('.dialog-zoomed-gallery__close-button')) {
        resetAll();
      }
    },
    true
  );
})();
